import type { ViewToken } from '@legendapp/list/react-native';
import { useDebouncedValue } from './useDebounce';
export default function useVisibleListItems<
  T extends {
    id: string;
  },
>(delay = 2000) {
  const {
    valueRef: visibleItemsRef,
    debouncedValue: visibleItems,
    setValue: setVisibleItems,
  } = useDebouncedValue<T[]>([], delay);
  const visibleItemIds = visibleItems.map((item) => item.id);
  const getVisibleItems = () => {
    return visibleItemsRef.current;
  };
  const getVisibleItemIds = () => {
    return visibleItemsRef.current.map((item) => item.id);
  };
  const onViewableItemsChanged = (info: {
    viewableItems: (ViewToken & {
      item: T;
    })[];
  }) => {
    const nextItems: T[] = [];
    for (const viewToken of info.viewableItems) {
      if (viewToken.item?.id) {
        nextItems.push(viewToken.item);
      }
    }
    const previousIds = visibleItemsRef.current.map((item) => item.id);
    const nextIds = nextItems.map((item) => item.id);
    if (
      previousIds.length === nextIds.length &&
      previousIds.every((id, index) => id === nextIds[index])
    ) {
      return;
    }
    visibleItemsRef.current = nextItems;
    setVisibleItems(nextItems);
  };
  return {
    visibleItemIds,
    visibleItems,
    visibleItemsRef,
    setVisibleItems,
    getVisibleItems,
    getVisibleItemIds,
    onViewableItemsChanged,
  };
}
